import { EventBroker } from "../../../lib/utils/event-broker";

export const EVENTS = {
    INIT: 'INIT',
    SHOW: 'SHOW',
    CLOSE: 'CLOSE',
    EXPORT: 'EXPORT',
    FINISH: 'FINISH',
}

class ExportTemplatesEventBroker extends EventBroker {
    initializationData = null;

    fire(name, dto) {
        if (name === EVENTS.INIT) {
            this.initializationData = dto;
        }

        super.fire(name, dto);
    }

    on(name, handler, shouldBeSingleSubscription = false) {
        super.on(name, handler, shouldBeSingleSubscription);

        // The modal is loaded asynchronously and can mount after INIT has fired.
        if (name === EVENTS.INIT && this.initializationData) {
            handler(this.initializationData);
        }
    }
}

export const exportTemplatesEventBroker = new ExportTemplatesEventBroker();
